var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#2C3765"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2828 30.2843C39.2828 25.1572 34.9657 21 29.6414 21C24.3171 21 20 25.1572 20 30.2843C20 34.9182 23.5251 38.7592 28.1349 39.4563V32.9689H25.6863V30.2843H28.1349V28.2389C28.1349 25.9124 29.5747 24.6263 31.7767 24.6263C32.8317 24.6263 33.9353 24.8078 33.9353 24.8078V27.0928H32.7189C31.5219 27.0928 31.1475 27.8082 31.1475 28.5435V30.2843H33.8212L33.3942 32.9689H31.1479V39.4572C35.7577 38.7604 39.2828 34.9194 39.2828 30.2843Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.d2629ff5b72549b2b000d303d06b8009.svg";
export { ForwardRef as ReactComponent };